import { render, staticRenderFns } from "./ServiceEmpty.vue?vue&type=template&id=714bdfeb&scoped=true"
import script from "./ServiceEmpty.vue?vue&type=script&lang=js"
export * from "./ServiceEmpty.vue?vue&type=script&lang=js"
import style0 from "./ServiceEmpty.vue?vue&type=style&index=0&id=714bdfeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714bdfeb",
  null
  
)

export default component.exports